import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3707151643/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/category/(components)/content.tsx");
